import React, { Component } from 'react';
import DataTable from 'react-data-table-component';
import Select from 'react-select';
import { BreadCrumb, Card, Modal, Confirm } from '../../components';
import { Translate } from '../../contexts/Language';
import { DataTableColumns } from '../../config/DataTableColumns';
import { Service } from '../../services';
import { Config } from '../../config';
import { ErrorMessage, Validator, VRules, VConditions } from '../../components/Validator';

export class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: {
        columns: DataTableColumns.userList,
        rows: [],
      },
      formData: {
        id: 0,
        firstName: '',
        lastName: '',
        status: false,
        role: null,
        email: '',
        qrStatus: false,
      },
      validation: {
        error: false,
        message: '',
      },
      modal: false,
      modalTitle: '',
      isNew: false,
    };
    this.onEdit = this.onEdit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.roles = [
      { value: 0, label: 'Admin' },
      { value: 1, label: 'Personnel' },
      { value: 2, label: 'Currency Manager' },
      { value: 3, label: 'Report Manager' },
    ];

    this.countryOptions = [];
  }

  componentDidMount() {
    this.onDataTable(true);
  }

  onDataTable() {
    Config.utilities.loadingFetch();

    Service.User.UserList().then(response => {
      if (response) {
        const { dataTable } = this.state;

        dataTable.rows = response;

        this.setState({
          dataTable,
        });
      }

      Config.utilities.loadingFetch();
      this.onCountryList();
    });
  }

  onCountryList() {
    Config.utilities.loadingFetch();

    Service.TransferOptions.CountryList().then(response => {
      if (response) {
        this.countryOptions = response.map(item => ({
          value: item.name,
          label: (
            <span className="capitalize">
              <img src={`https://www.countryflags.io/${item.code}/shiny/24.png`} alt="Flag" width="24" className="mb-1 mr-1" onError={e => { e.target.src = '/assets/images/flags/null.png'; }} />
              {item.name}
            </span>
          ),
        }));
      }

      Config.utilities.loadingFetch();
    });
  }

  onFormChange(value, key) {
    const { formData } = this.state;

    formData[key] = value;

    this.setState({
      formData,
    });
  }

  onNew(modal) {
    this.setState({
      formData: {
        id: 0,
        role: null,
        status: false,
        country: [],
      },
      modal: !(modal === false),
      modalTitle: Translate('Add New User'),
      validation: {
        error: false,
        message: '',
      },
      isNew: true,
    });
  }

  onEdit(id) {
    Config.utilities.loadingFetch();

    const { formData } = this.state;
    [formData.role] = this.roles.filter(filter => filter.value === 1);
    formData.status = false;

    this.setState(
      {
        modal: true,
        validation: {
          error: false,
          message: '',
          formData,
        },
        isNew: false,
        modalTitle: Translate('Edit User'),
      },
    );

    Service.User.Detail({ id }).then(response => {
      if (response) {
        [response.role] = this.roles.filter(filter => filter.value === response.role);

        if (response.country.length > 0) {
          response.country = this.countryOptions.filter(item => response.country.includes(item.value));
        }

        this.setState({
          formData: response,
        });
      }
      Config.utilities.loadingFetch();
    });
  }

  onSave() {
    Confirm({
      title: Translate('Are you sure?'),
      type: { warning: true },
      description: Translate('This withdrawal will be confirmed'),
      onConfirm: () => {
        const { formData: form } = this.state;

        const data = {
          Id: form.id,
          FirstName: form.firstName,
          LastName: form.lastName,
          Status: form.status,
          Role: form.role.value,
          email: form.email,
          country: (form.country ? form.country.map(item => item.value) : []),
          QrStatus: form.qrStatus,
        };

        if (this.isValid(form)) {
          Config.utilities.loadingFetch();

          Service.User.Save(data).then(response => {
            if (response.error) {
              this.setState({
                validation: {
                  error: response.error,
                  message: response.message,
                },
              });
            } else {
              this.onNew(false);
              this.onDataTable();
            }

            Config.utilities.loadingFetch();
          });
        }
      },
      onCancel: () => { },
    });
  }

  onDelete(id) {
    Confirm({
      title: Translate('Are you sure?'),
      type: { warning: true },
      description: Translate('This withdrawal will be confirmed'),
      onConfirm: () => {
        Config.utilities.loadingFetch();
        Service.User.Delete({ id }).then(response => {
          if (response.error) {
            this.setState({
              validation: {
                error: response.error,
                message: response.message,
              },
            });
          } else {
            this.onNew(false);
            this.onDataTable();
          }
          Config.utilities.loadingFetch();
        });
      },
      onCancel: () => { },
    });
  }

  isValid(data) {
    const { isNew } = this.state;

    VRules.firstName = {
      Invalid: value => VConditions.Required(value),
      Message: Translate('First name can not be empty.'),
    };

    VRules.lastName = {
      Invalid: value => VConditions.Required(value),
      Message: Translate('Last name can not be empty.'),
    };

    if (isNew) {
      VRules.email = {
        Invalid: value => VConditions.Required(value),
        Message: Translate('Email can not be empty.'),
      };
    }
    const error = Validator.Valid(data, this.Refs);
    this.setState({
      validation: error,
    });

    return !error.error;
  }

  render() {
    const { modalTitle, modal, validation, formData, isNew, dataTable } = this.state;
    return (
      <>
        <BreadCrumb Title={Translate('Users')} Name={Translate('Users')} />
        <Card Title="Users" Description="Personnel Panel Users">
          <Modal Title={modalTitle} Show={modal} onClose={() => this.setState({ modal: false })}>
            <div className="row mt-1 mb-1">
              <p className="text-muted mb-2 ml-1 col-md-12 font-12">{Translate('Role Information')}</p>
              <div className="col-md-12">
                <form className="form-horizontal" name="saveForm" ref={this.Refs}>
                  <ErrorMessage Validation={validation} />
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="login" className="col-sm-4 col-form-label">{Translate('First Name')}</label>
                    <div className="col-sm-8">
                      <input className="form-control" type="text" id="firstName" name="firstName" value={formData.firstName} autoComplete="off" onChange={e => this.onFormChange(e.target.value, 'firstName')} />
                    </div>
                  </div>
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="transferOption" className="col-sm-4 col-form-label">{Translate('Last Name')}</label>
                    <div className="col-sm-8">
                      <input className="form-control" type="text" id="lastName" name="lastName" value={formData.lastName} autoComplete="off" onChange={e => this.onFormChange(e.target.value, 'lastName')} />
                    </div>
                  </div>
                  {isNew ?
                    (
                      <div className="form-group row ml-1 mr-1">
                        <label htmlFor="transferOption" className="col-sm-4 col-form-label">{Translate('Email')}</label>
                        <div className="col-sm-8">
                          <input className="form-control" type="text" id="email" name="email" value={formData.email} autoComplete="off" onChange={e => this.onFormChange(e.target.value, 'email')} />
                        </div>
                      </div>
                    ) : ''}
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="transferType" className="col-sm-4 col-form-label">{Translate('Status')}</label>
                    <div className="col-sm-8">
                      <input type="checkbox" id="status" name="status" switch="dark" checked={formData.status} onChange={() => this.onFormChange(!formData.status, 'status')} />
                      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                      <label htmlFor="status" data-on-label="Yes" data-off-label="No" className="mt-2 mb-1" />
                    </div>
                  </div>
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="transferType" className="col-sm-4 col-form-label">{Translate('User Role')}</label>
                    <div className="col-sm-8">
                      <Select
                        id="transferType"
                        value={formData.role}
                        onChange={option => this.onFormChange(option, 'role')}
                        options={this.roles}
                        isMulti={false}
                        name="transferType"
                      />
                      {/* <input type="checkbox" id="isAdmin" name="isAdmin" switch="dark" checked={this.state.formData.isAdmin} onChange={(e) => this.onFormChange(!this.state.formData.isAdmin, "isAdmin")} />
                                            <label htmlFor="isAdmin" data-on-label="Yes" data-off-label="No" className="mt-2 mb-1"></label> */}
                    </div>
                  </div>
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="transferOption" className="col-sm-4 col-form-label">{Translate('Reportable Countries')}</label>
                    <div className="col-md-8">
                      <Select
                        id="reportableCountries"
                        value={formData.country}
                        onChange={option => this.onFormChange(option, 'country')}
                        options={this.countryOptions}
                        isMulti
                        name="reportableCountries"
                        disabled
                      />
                    </div>
                  </div>
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="transferType" className="col-sm-4 col-form-label">{Translate('Qr Status')}</label>
                    <div className="col-sm-8">
                      <input type="checkbox" id="qrStatus" name="qrStatus" switch="dark" checked={formData.qrStatus} onChange={() => this.onFormChange(!formData.qrStatus, 'qrStatus')} />
                      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                      <label htmlFor="qrStatus" data-on-label="On" data-off-label="Off" className="mt-2 mb-1" />
                    </div>
                  </div>
                  <div className="form-group row ml-1 mr-1">
                    {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                    <label htmlFor="save-form" className="col-sm-4 col-form-label" />
                    <div className="col-sm-8">
                      <button type="button" className="btn btn-info float-right" onClick={() => this.onSave()}>
                        <i className="far fa-save mr-2" />
                        {Translate('Save Form')}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Modal>
          <div className="row">
            <div className="col-md-12">
              <button type="button" className="btn btn-info position-absolute add-new-button tabless" onClick={() => this.onNew()}>
                <i className="fas fa-plus mr-2" />
                {Translate('Add New Login')}
              </button>
              {dataTable.rows.length === 0 ?
                (
                  <div className="alert alert-light" role="alert">
                    <em>
                      <strong className="mr-1">No record!</strong>
                      {Translate('No records found for the filter.')}
                    </em>
                  </div>
                ) :
                (
                  <DataTable
                    noHeader
                    columns={dataTable.columns(this.onEdit, this.onDelete)}
                    data={dataTable.rows}
                    defaultSortField="id"
                    defaultSortAsc={false}
                    pagination
                    highlightOnHover
                  />
                )}
            </div>
          </div>
        </Card>
      </>
    );
  }
}
